import { TxOverview } from '../../types'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

export interface ClaimTransactionOverviewProps {
  txOverview: TxOverview
}

export function ClaimTransactionOverview({ txOverview }: ClaimTransactionOverviewProps) {
  const {
    reward: { token, value },
  } = txOverview

  return (
    <TransactionOverview>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Outcome</TransactionOverview.Label>
        <TransactionOverview.TokenAmountOutcome
          token={token}
          amount={value}
          postFix="Claimed"
          amountDataTestId={testIds.farmDetails.claimDialog.transactionOverview.rewardAmount}
          usdValueDataTestId={testIds.farmDetails.claimDialog.transactionOverview.rewardAmountUSD}
          showUsdValue
        />
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}
